/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getTickerLot } from '../fn/ticker-lot/get-ticker-lot';
import { GetTickerLot$Params } from '../fn/ticker-lot/get-ticker-lot';
import { TickerLotDto } from '../models/ticker-lot-dto';

@Injectable({ providedIn: 'root' })
export class GeneratedTickerLotService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getTickerLot()` */
  static readonly GetTickerLotPath = '/api/ticker/lots/{id}';

  /**
   * Gets a lot by its id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTickerLot()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTickerLot$Response(params: GetTickerLot$Params, context?: HttpContext): Observable<StrictHttpResponse<TickerLotDto>> {
    return getTickerLot(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets a lot by its id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTickerLot$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTickerLot(params: GetTickerLot$Params, context?: HttpContext): Observable<TickerLotDto> {
    return this.getTickerLot$Response(params, context).pipe(
      map((r: StrictHttpResponse<TickerLotDto>): TickerLotDto => r.body)
    );
  }

}
